import React, { FC, useCallback, useMemo } from 'react';
import { Dispatch } from 'redux';
import { connect, ConnectedProps, useDispatch } from 'react-redux';

import { INoAuthData } from '@stelecom/ui-react/components/blocks/notAuth/types';
import NoAuth from '@stelecom/ui-react/components/blocks/notAuth';

import { openCitySelect } from '~/src/store/actions/citySelect';
import { login } from '~/src/store/actions/auth';
import { TState } from '~/src/store';
import { citiesListForHeader } from '~/src/store/selectors/city';

import * as ST from './styled';
import { loginModalWindow } from '~/src/store/actions/LoginModalWindow';

export interface IConnectedNotAuthProps extends TPropsFromRedux {
  data: INoAuthData;
  sendEvent?: () => void;
}

const ConnectedNotAuth: FC<IConnectedNotAuthProps> = ({
  data,
  sendEvent,
  openCitySelect,
  city,
  cities,
  auth,
  changeStateModalWindow
}) => {
  const dispatch = useDispatch();

  const authSubmitHandler = useCallback(
    async(username, password, rememberMe, referrer, domain) => {
      dispatch(login(username, password, rememberMe, referrer, domain));
    },
    [dispatch]
  );

  const loginMessage = useMemo(() => auth?.loginError || undefined, [auth?.loginError]);

  return (
    <ST.Wrapper>
      <NoAuth
        {...data}
        sendEvent={sendEvent}
        cities={cities}
        city={city}
        authSubmit={authSubmitHandler}
        loginMessage={loginMessage}
        openCitySelect={openCitySelect}
        changeStateModalWindow={changeStateModalWindow}
      />
    </ST.Wrapper>
  );
};

const mapStateToProps = (state: TState) => ({
  city: state.city.currentCity,
  cities: citiesListForHeader(state),
  auth: state.auth,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  openCitySelect: () => dispatch(openCitySelect()),
  changeStateModalWindow: () => dispatch(loginModalWindow()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ConnectedNotAuth);
